import { useSelector } from 'react-redux';
import { Store } from 'src/redux/Store';
import FormSingleSelect, { SelectItem } from 'src/components/Control/FormControls/FormSingleSelect';
import { ErrorBag } from 'src/models/ErrorModel';
import { FormControl } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FORM_ID } from 'src/models/FormModel';
import { FundraisingTypes } from 'src/constants/FundraisingTypes';

const useStyles = makeStyles(() => ({
  formControl: {
    width: '100%',
    marginTop: 0,
    marginBottom: '8px',
  },
}));

interface Props {
  disabled?: boolean,
  form: FORM_ID,
  name: string,
  onChange: (value:FundraisingTypes, field: string) => void,
  value?: string,
}

const FundraisingTypeSelector = (props: Props) => {
  const classes = useStyles();

  const {
    disabled, form, name, onChange, value,
  } = props;

  const types = [
    FundraisingTypes.standard,
    FundraisingTypes.event,
    FundraisingTypes.matching,
    FundraisingTypes.ticketing,
  ];

  const errors: ErrorBag =
    useSelector((state:Store) => state.errors[form] || {} as ErrorBag);

  const getItems = () => {
    const items:SelectItem[] = [];
    types.sort(
      (a, b) => a.localeCompare(b),
    ).map((item: any) => {
      items.push({
        id: item,
        text: item,
      } as SelectItem);
      return items;
    });
    return items;
  };

  return (
    <FormControl
      variant="outlined"
      className={classes.formControl}
      error={!!errors[name]}
      key={`form-control-${name}`}>
      <FormSingleSelect
        form={form}
        items={getItems()}
        label="Type"
        name={name}
        onChange={onChange}
        value={value || ''}
        style={{ minWidth: '116px' }}
        disabled={disabled}
        margin="dense"
        noMarginTop />
    </FormControl>
  );
};

export default FundraisingTypeSelector;
